/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_TInputs */

const en_mk_tut_issue_t = /** @type {(inputs: Mk_Tut_Issue_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating your first issue`)
};

const id_mk_tut_issue_t = /** @type {(inputs: Mk_Tut_Issue_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat issue pertama`)
};

/**
* | output |
* | --- |
* | "Creating your first issue" |
*
* @param {Mk_Tut_Issue_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_t = /** @type {((inputs?: Mk_Tut_Issue_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_t(inputs)
	return en_mk_tut_issue_t(inputs)
});